<template>
    <div>
        <draggable
         tag="ul"
         class="list-group mb-3"
         v-model="questions"
         v-bind="dragOptions"
         @start="isDragging = true"
         @end="isDragging = false"
         @change="dragMove"
         handle=".handle">
            <li class="draggable-item mb-3" v-for="(question, index) in questions" :key="question.id">
                <div class="card">
                    <div class="card-header handle d-flex w-100 position-relative p-1">
                        <icon icon="arrows-alt-v" class="handle my-auto" pull="right" size="lg"></icon>
                        <span class="my-auto ml-1">Question {{question.order}}</span>
                        <select v-model="question.type" class="form-control w-auto my-auto ml-3">
                            <option value="1">Multiple Choice</option>
                            <option value="2">Free Text</option>
                            <option value="3">Checkboxes</option>
                        </select>
                        <div class="form-check my-auto ml-3">
                            <input class="form-check-input" type="checkbox" v-model="question.required" value="" id="typeCheck">
                            <label class="form-check-label" for="typeCheck">Required</label>
                        </div>
                        <button type="button" class="btn btn-danger btn-delete-question" @click="deleteQuestion(index)">Delete Question</button>
                    </div>
                    <b-form inline class="card-body">
                        <div class="form-group col-12">
                            <div class="input-group mb-3 w-100">
                                <div class="input-group-prepend w-auto">
                                    <span class="input-group-text w-auto" id="inputGroup-sizing-lg">Question Text</span>
                                </div>
                                <input v-model="question.questionText" type="text" class="form-control" placeholder="Question Text">
                            </div>
                            <div class="input-group mb-3 w-100">
                                <div class="input-group-prepend w-100">
                                    <span class="input-group-text w-100" id="inputGroup-sizing-lg">Additional Information</span>
                                </div>
                                <div class="w-100">
                                    <html-editor v-model="question.help"/>
                                </div>
                                
                            </div>
                        </div>
                        <div class="w-100">
                            <answer class="mt-0"
                                    @answersChanged="answersChanged"
                                    :questionId="question.id"
                                    :save="save"
                                    :saved="saved"></answer>
                        </div>
                    </b-form>
                </div>
            </li>
        </draggable>
        <button type="button" class="btn btn-primary" @click="addQuestion"><icon icon="plus-circle" /> Add question</button>
    </div>
</template>

<script>
import answer from './Answers.vue'
import draggable from 'vuedraggable'
import HtmlEditor from './../../../misc/HtmlEditor';

export default {
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
                group: {
                    put: false,
                    pull: false
                }
            }
        }
    },
    components: {
        draggable,
        answer,
        HtmlEditor
    },
    props: {
        questionnaireId: String,
        save: Boolean,
        saved: Boolean
    },
    data(){
        return {
            questions: [],
        }
    },
    
    methods: {
        redirectToInformation: function(questionId){
            this.$router.push('/admin/question/' + questionId + '/additional-information')
        },
        answersChanged: function(answers, questionId){
            this.questions.forEach((question, index) => {
                if(question.id === questionId){
                    this.questions[index]['answers'] = answers
                }
            })
        },
        addQuestion: function(){
            let emptyQuestion = {
                order: this.questions.length + 1,
                questionText: "",
                questionTextTranslationKey: "",
                questionnaireId: this.questionnaireId,
                required: false,
                type: 1
            }
            this.questions.push(emptyQuestion)
            _.orderBy(this.questions, 'order')
        },
        deleteQuestion: function(index){
            let id = this.questions[index].id
            if(id){
                this.$http.delete(`/api/questionnaires/question/delete/${id}`)
                .then(response => {
                    console.log('deleted')
                    this.questions.splice(index, 1)
                })
                .catch(error => {
                    console.log(error)
                })
            } 
            else {
                this.questions.splice(index, 1)
            }
        },
        loadQuestions: function(){
            let self = this
            this.$http.get(`/api/questionnaires/questionnaire/${this.questionnaireId}/questions`)
            .then(response => {
                let data = response.data
                self.questions = data
                self.questions = _.orderBy(self.questions, 'order')
                this.$emit('answersChanged', this.answers, this.questionId)
            })
        },
        dragMove: function(evt){
            this.questions.forEach((item, index) => {
                item.order = index + 1
            });
        },
        formatTranslationKey: function(value, index){
            this.questions[index].questionTextTranslationKey = value
        }
    },
    mounted: function(){
        this.loadQuestions()
    },
    watch: {
        save(value){
            if(value === true){
                this.$emit('questionsChanged', this.questions, this.questionnaireId)
            }
        },
        saved(value){
            if(value === true){
                this.loadQuestions()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    form > fieldset {
        margin: auto !important;
        margin-top: 0 !important;
    }
    .flip-list-move {
    transition: transform 1s;
    }
    .no-move {
    transition: transform 0s;
    }
    .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    }
    .list-group {
    min-height: 20px;
    }
    .draggable-item {
        .card-header{
            cursor: move
        }
    }
    .draggable-item{
        icon {
            cursor: pointer;
        }
    }
    ul {
        list-style-type: none;
    }

    .btn-delete-question {
        position: absolute;
        right: 12px;
        top: 8px;
    }
</style>

